"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBlockProof = exports.buildMerkleProof = exports.getBlockHeader = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
var solidity_1 = require("@ethersproject/solidity");
var merkleTree_1 = __importDefault(require("../utils/merkleTree"));
var checkpoint_1 = require("../utils/checkpoint");
var checks_1 = require("../checks");
var contracts_1 = require("../utils/contracts");
var blocks_1 = require("../utils/blocks");
exports.getBlockHeader = function (block) {
    return solidity_1.keccak256(["uint256", "uint256", "bytes32", "bytes32"], [block.number, block.timestamp, block.transactionsRoot, block.receiptsRoot]);
};
exports.buildMerkleProof = function (burnTxBlock, blocks, checkpointId) { return __awaiter(void 0, void 0, void 0, function () {
    var blockProof;
    return __generator(this, function (_a) {
        blockProof = new merkleTree_1.default(blocks.map(exports.getBlockHeader)).getProof(exports.getBlockHeader(burnTxBlock));
        return [2 /*return*/, {
                burnTxBlockNumber: bignumber_1.BigNumber.from(burnTxBlock.number).toNumber(),
                burnTxBlockTimestamp: bignumber_1.BigNumber.from(burnTxBlock.timestamp).toNumber(),
                transactionsRoot: burnTxBlock.transactionsRoot,
                receiptsRoot: burnTxBlock.receiptsRoot,
                headerBlockNumber: checkpointId.toNumber(),
                blockProof: blockProof,
            }];
    });
}); };
exports.buildBlockProof = function (rootChainProvider, maticChainProvider, rootChainContractAddress, blockNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var checkpointManager, checkpointId, checkpoint, startBlock, endBlock, blocks, burnTxBlock;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // Check that the block containing is checkpointed on mainnet.
                if (!checks_1.isBlockCheckpointed(rootChainProvider, rootChainContractAddress, blockNumber)) {
                    throw new Error("Block has not been checkpointed yet");
                }
                return [4 /*yield*/, contracts_1.getCheckpointManager(rootChainProvider, rootChainContractAddress)];
            case 1:
                checkpointManager = _a.sent();
                return [4 /*yield*/, checkpoint_1.findBlockCheckpointId(checkpointManager, blockNumber)];
            case 2:
                checkpointId = _a.sent();
                return [4 /*yield*/, checkpointManager.headerBlocks(checkpointId.toString())];
            case 3:
                checkpoint = _a.sent();
                startBlock = bignumber_1.BigNumber.from(checkpoint.start).toNumber();
                endBlock = bignumber_1.BigNumber.from(checkpoint.end).toNumber();
                return [4 /*yield*/, blocks_1.getBlocksInRange(maticChainProvider, startBlock, endBlock)];
            case 4:
                blocks = _a.sent();
                burnTxBlock = blocks[bignumber_1.BigNumber.from(blockNumber).sub(startBlock).toNumber()];
                return [2 /*return*/, exports.buildMerkleProof(burnTxBlock, blocks, checkpointId)];
        }
    });
}); };
